<template>
  <article class="project-card showcase">
    <div class="poster">
      <span class="poster-label">{{ fmt("poster_label", { n: indexLabel }) }}</span>
      <div class="poster-stack">
        <div class="poster-art">
          <img
            v-if="project.imageUrl"
            :src="project.imageUrl"
            :alt="project.name"
            class="poster-cover-img"
          />
          <i v-else class="poster-logo"></i>
        </div>
        <h3>{{ project.name }}</h3>
        <!-- <span class="english">{{ project.nameEn }}</span> -->
      </div>
      <!-- <span class="poster-bottom">{{ project.posterBottom || t("poster_bottom") }}</span> -->
    </div>
    <div class="project-content">
      <div class="row">
        <span class="tag">{{ t("tag_debut") }}</span>
        <span class="live">{{ t("live_demo") }}</span>
      </div>
      <h3>{{ project.name }}</h3>
      <div class="subtext">{{ t("sub_issuer") }} · {{ project.issuer }}</div>
      <div class="price" v-html="priceHtml"></div>
      <div class="price-note">{{ t("card_price_note") }}</div>
      <div class="row progress-label">
        <span>{{ t("progress_label") }}</span>
        <span>{{ progressPercent }}</span>
      </div>
      <div class="progress"><i :style="{ width: progressWidth }"></i></div>
      <div class="row progress-label">
        <span
          ><b>{{ sold }}</b> / {{ supplyFormatted }} {{ t("stat2u") }}</span
        >
        <span>{{ t("limited") }}</span>
      </div>
      <button type="button" class="btn gold" @click="$emit('open', project.id)">
        {{ t("view_project") }}
      </button>
    </div>
  </article>
</template>

<script>
import { fmtCoin } from "@/film/pricing";

export default {
  name: "ProjectShowcaseCard",
  props: {
    project: { type: Object, required: true },
    index: { type: Number, required: true },
    sold: { type: Number, default: 0 },
    t: { type: Function, required: true },
    fmt: { type: Function, required: true },
  },
  computed: {
    indexLabel() {
      return String(this.index + 1).padStart(3, "0");
    },
    supplyFormatted() {
      return this.project.supply.toLocaleString("en-US");
    },
    progressPercent() {
      const pct = (this.sold / this.project.supply) * 100;
      return `${pct.toFixed(1).replace(/\.0$/, "")}%`;
    },
    progressWidth() {
      return `${(this.sold / this.project.supply) * 100}%`;
    },
    priceHtml() {
      const coin = this.project.coin;
      if (this.project.mode === "step") {
        const s = this.project.step;
        return `${fmtCoin(s.start, coin)} ${coin} <small>+${fmtCoin(s.inc, coin)} / ${this.t("stat2u")}</small>`;
      }
      return `${fmtCoin(this.project.fixed, coin)} ${coin} <small>${this.t("price_unit")}</small>`;
    },
  },
};
</script>
